import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import React from 'react';
import Option from './Option';
import cx from 'classnames';
import { components } from 'react-select';
import Chip from '@material-ui/core/Chip';
import Typography from '@material-ui/core/Typography';
import { emphasize } from '@material-ui/core/styles/colorManipulator';
import FormTextInput from '../Text';
import DropdownIndicatorIcon from './DropdownIndicatorIcon';
import Icon from '../../../core/Icon';
export var styles = function styles(theme) {
  return {
    // root: {
    //   flexGrow: 1,
    //   height: 250,
    // },
    input: {
      display: 'flex',
      padding: 0
    },
    icon: {
      color: 'inherit'
    },
    chip: {
      margin: "".concat(theme.spacing(0.5), "px ").concat(theme.spacing(0.25), "px"),
      height: 'auto'
    },
    chipDeleteIcon: {
      margin: "".concat(theme.spacing(0.25), "px ").concat(theme.spacing(0.25), "px ").concat(theme.spacing(0.25), "px ").concat(-theme.spacing(1), "px"),
      fontSize: '1.25em',
      height: '1em',
      width: '1em'
    },
    chipIcon: {
      fontSize: '1.25em'
    },
    chipFocused: {
      backgroundColor: emphasize(theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700], 0.08)
    },
    noOptionsMessage: {
      padding: "".concat(theme.spacing(1), "px ").concat(theme.spacing(2), "px")
    },
    placeholder: {
      opacity: 0.54
    },
    optionIcon: {
      fontSize: '1em',
      marginRight: theme.spacing(0.5)
    },
    optionMenuItemRootFocused: {
      backgroundColor: theme.getStyle('Form.Input.MultiSelect').optionFocusedBackgroundColor
    }
  };
};

var MultiValueLabel = function MultiValueLabel(props) {
  return React.createElement(React.Fragment, null, React.createElement(components.MultiValueLabel, props));
};

var MultiValue = function MultiValue(props) {
  var _cx;

  var classes = props.selectProps.classes;
  var iconEl = props.data.icon ? React.createElement(Icon, {
    type: props.data.icon,
    className: classes.chipIcon
  }) : undefined;
  return React.createElement(Chip, {
    tabIndex: -1,
    label: props.children,
    className: cx((_cx = {}, _defineProperty(_cx, classes.chip, true), _defineProperty(_cx, classes.chipFocused, props.isFocused), _cx)),
    classes: {
      deleteIcon: classes.chipDeleteIcon
    },
    onMouseDown: function onMouseDown(e) {
      return e.stopPropagation();
    },
    onDelete: props.removeProps.onClick,
    icon: iconEl
  });
};

var inputComponent = function inputComponent(_ref) {
  var inputRef = _ref.inputRef,
      props = _objectWithoutProperties(_ref, ["inputRef"]);

  return React.createElement("div", Object.assign({
    ref: inputRef
  }, props));
};

var Control = function Control(props) {
  var textFieldProps = props.selectProps.textFieldProps || {};
  return React.createElement(FormTextInput, Object.assign({
    disabled: props.isDisabled,
    variant: props.selectProps.variant,
    error: props.selectProps.error,
    helperText: props.selectProps.helperText,
    label: props.selectProps.label,
    placeholder: props.selectProps.placeholder
  }, textFieldProps, {
    InputProps: _objectSpread({}, textFieldProps.InputProps, {
      inputComponent: inputComponent,
      inputRef: props.innerRef,
      inputProps: _objectSpread({
        className: props.selectProps.classes.input,
        children: props.children
      }, props.innerProps)
    })
  }));
};

var Placeholder = function Placeholder(props) {
  return React.createElement(Typography, Object.assign({
    color: "inherit",
    className: props.selectProps.classes.placeholder
  }, props.innerProps), props.children);
};

var NoOptionsMessage = function NoOptionsMessage(props) {
  return React.createElement(Typography, Object.assign({
    color: "textSecondary",
    className: props.selectProps.classes.noOptionsMessage
  }, props.innerProps), props.children);
};

var DropdownIndicator = function DropdownIndicator(props) {
  return React.createElement(components.DropdownIndicator, props, React.createElement(DropdownIndicatorIcon, {
    className: props.selectProps.classes.icon
  }));
};

var IndicatorSeparator = function IndicatorSeparator() {
  return null;
};

var Input = function Input(props) {
  if (props.isHidden) return React.createElement(components.Input, props); //alignment fix

  return React.createElement("span", {
    style: {
      lineHeight: "".concat(30 - 2, "px")
    }
  }, React.createElement(components.Input, props));
};

var customComponents = {
  Input: Input,
  Control: Control,
  Option: Option,
  MultiValue: MultiValue,
  MultiValueLabel: MultiValueLabel,
  NoOptionsMessage: NoOptionsMessage,
  Placeholder: Placeholder,
  DropdownIndicator: DropdownIndicator,
  IndicatorSeparator: IndicatorSeparator
};
export default customComponents;